import { getDateMoment, getDestinationTimeZone } from "../../../helpers/dateHelper";
import { SortOrder } from "../../../hooks/useTableSort";
import { Type as InternalBookingType } from "../../../models/internalBooking";

export type InternalBookingsFilters = {
    search: string;
    dockId: string | undefined;
    arrivalTime: number | null;
    departureTime: number | null;
    types: InternalBookingType[];
    rowsPerPage: number;
    page: number;
    order: SortOrder;
};

export const DISP_MANAGE_INTERNAL_BOOKINGS_FILTERS_INIT: InternalBookingsFilters = {
    search: "",
    dockId: undefined,
    departureTime: null,
    arrivalTime: null,
    types: [],
    page: 0,
    rowsPerPage: 100,
    order: ["arrivalTime desc"],
};

export function buildInternalBookingsSearchPayload(filters: InternalBookingsFilters, timeZone?: string) {
    return {
        offset: filters.page * filters.rowsPerPage,
        limit: filters.rowsPerPage,
        textSearch: filters.search,
        order: filters.order,
        columns: {},
        filter: buildInternalBookingsSearchPayloadFilters(filters, getDestinationTimeZone(timeZone)),
    };
}

function buildInternalBookingsSearchPayloadFilters(filters: InternalBookingsFilters, timeZone: string) {
    const { dockId, types, arrivalTime, departureTime } = filters;

    const filterArray: object[] = [];

    if (dockId) {
        filterArray.push({ dockId: { $eq: dockId } });
    }

    if (types.length > 0) {
        const bsFilterArray: object[] = [];
        types.forEach(st => bsFilterArray.push({ type: st.toString() }));
        filterArray.push({ $or: bsFilterArray });
    }

    if (arrivalTime && !departureTime) {
        const startDate = getDateMoment(arrivalTime, { timeZone }).startOf("day");
        const endDate = getDateMoment(arrivalTime, { timeZone }).endOf("day");
        filterArray.push(
            { arrivalTime: { $gte: startDate.valueOf() } },
            { arrivalTime: { $lte: endDate.valueOf() } },
        );
    }

    if (departureTime && !arrivalTime) {
        const startDate = getDateMoment(departureTime, { timeZone }).startOf("day");
        const endDate = getDateMoment(departureTime, { timeZone }).endOf("day");
        filterArray.push(
            { departureTime: { $gte: startDate.valueOf() } },
            { departureTime: { $lte: endDate.valueOf() } },
        );
    }

    if (departureTime && arrivalTime) {
        const startDate = getDateMoment(arrivalTime, { timeZone }).startOf("day");
        const endDate = getDateMoment(departureTime, { timeZone }).endOf("day");
        filterArray.push(
            { arrivalTime: { $gte: startDate.valueOf() } },
            { departureTime: { $lte: endDate.valueOf() } },
        );
    }

    return { $and: filterArray };
}
